export default {
  default: () => import("/Users/pavel/Work/xsquare-2024/layouts/default.vue").then(m => m.default || m)
}